import { useMutation } from '@tanstack/react-query';

import type { Comparison } from '../../../types/BaselineMeasurements';
import { baselineMeasurementService } from '../../../Domain/BaselineMeasurements/Services';

type ComparisonCompleteData = Pick<Comparison, 'comparisonId'>;

const mutationFn = (data: ComparisonCompleteData) => {
  return baselineMeasurementService.completeComparison(data.comparisonId);
};

export const useComparisonCompleteMutation = () => {
  return useMutation<unknown, unknown, ComparisonCompleteData>(mutationFn);
};
